import { Config as ConfigIcon } from "@volt_developers/react-ui-components";

import { applicationRoutes } from "modules/applications";
import { accountsRoutes } from "modules/bank-accounts";
import { customersRoutes } from "modules/customers";
import { userManagementRoutes } from "modules/user-management";

import type { Route } from "../RouteModel";

export const configurationRoutes: Route = {
  i18nName: "Configuration",
  icon: ConfigIcon,
  path: "/configuration",
  showChildrenInSidebar: true,
  children: [
    applicationRoutes,
    accountsRoutes,
    customersRoutes,
    userManagementRoutes,
  ],
};
